import React, { useState, useEffect } from 'react';
import { Button, Input, message } from 'antd';
import { restApi, message_info, message_success, message_error, message_warning, message_loading } from '../../../apis';
import CenterPofileDetailCreate from '../atoms/center_profile_detail_create';
import dayjs from 'dayjs';

const CreateNewCenter = (props) => {
  const { setGModal, setLoading, loading, setReFresh, ...rest } = props;
  const [messageApi, contextHolder] = message.useMessage();
  const [isRead, setRead] = useState(false);
  const [data, setData] = useState({});
  const [optPlans, setOptPlans] = useState([]);

  useEffect(() => {
    // 로딩
    setLoading(true);
    // 데이터 가져오기
    (async (args) => {
      const response = await restApi.get(`/admin/plan`);
      const options = response?.data?.payload?.planList || [
        {
          value: null,
          label: `구독한 플랜(프로모션) 없음`,
        },
      ];
      setOptPlans(() => {
        let resOptions = [];

        let i = 0;
        for (; i < options?.length; i++) {
          const item = options[i];
          resOptions.push({
            value: item.id,
            label: item.name,
          });
        }
        resOptions.push({
          value: null,
          label: `구독한 플랜(프로모션) 없음`,
        });
        return resOptions;
      });

      setLoading(false);
    })();

    setTimeout(() => {
      setLoading(false);
    }, 5000);
  }, []);

  return (
    <div style={{ ...styles.container }}>
      {/*---------------------------------------------------------------------------------------------------- */}
      {contextHolder}
      {/*---------------------------------------------------------------------------------------------------- */}
      <CenterPofileDetailCreate
        data={data}
        setData={setData}
        isRead={isRead}
        setRead={setRead}
        optPlans={optPlans}
        {...props}
      />
      {/* ---------------------------------------------------------------------------------------------------- */}
      <div style={{ ...styles.footer }}>
        <Button
          width={69}
          height={38}
          style={{
            //font
            fontWeight: 500,
            fontSize: '1.5rem',
            lineHeight: '1.8rem',
            letterSpacing: 0.43,
          }}
          onClick={(e) => {
            setGModal((prev) => {
              return {
                ...prev,
                show: false,
              };
            });
          }}
        >
          {'취소'}
        </Button>
        <Button
          width={69}
          height={38}
          style={{
            marginLeft: '1rem',
            background: '#A8AAAE',
            boxShadow: '0px 2px 4px rgba(165, 163, 174, 0.3)',
            borderRadius: '0.6rem',

            //font
            fontWeight: 500,
            fontSize: '1.5rem',
            lineHeight: '1.8rem',
            letterSpacing: 0.43,
            color: '#FFFFFF',
          }}
          onClick={(e) => {
            (async () => {
              let errorMsg = '센터를 등록하는데 실패하였습니다.[정보확인]';
              let isSave = true;
              if (data?.isChangePasword) {
                if (data?.password != data?.confirmPwd) {
                  isSave = false;
                  errorMsg = '패스워드를 확인해 주세요';
                }
              } else {
                isSave = false;
                errorMsg = '패스워드를 입력해 주세요';
              }

              if (!data?.center_name) {
                isSave = false;
                errorMsg = '센터 이름을 입력해 주세요';
              } else if (!data?.account_name) {
                isSave = false;
                errorMsg = '센터장 이름을 입력해 주세요';
              } else if (!data?.account_email) {
                isSave = false;
                errorMsg = '이메일을 입력해 주세요';
              } else if (!data?.account_phone) {
                isSave = false;
                errorMsg = '전화번호를 입력해 주세요';
              }

              //  이메일 유효성 체크
              let emailRegex = new RegExp('[a-z0-9]+@[a-z]+.[a-z]{2,3}');
              if (
                String(data?.account_email || '').length === 0 ||
                !emailRegex.test(data?.account_email) 
              ) {
                isSave = false;
                errorMsg = '정상 이메일 입력해 주세요';
              }

              if (isSave) {
                await restApi
                  .post('/admin/center', {
                    center_name: data?.center_name,
                    center_phone: data?.center_phone,
                    // center_identifyCode: data?.center_identifyCode,
                    // center_createdAt:
                    //   data?.center_createdAt &&
                    //   dayjs(data?.center_createdAt).format(
                    //     'YYYY-MM-DD 00:00:00'
                    //   ),
                    center_comment: data?.center_comment,
                    center_password: data?.password,
                    center_ipAddress: data?.center_ipAddress || '0.0.0.0',
                    // contract_id: data?.contract_id,
                    contract_autoPayment: data?.contract_autoPayment,
                    contract_paymentMethod: data?.contract_paymentMethod,
                    contract_paymentAmount: data?.contract_paymentAmount,
                    contract_paidDate:
                      data?.contract_paidDate &&
                      dayjs(data.contract_paidDate).format('YYYY-MM-DD HH:mm:ss'),
                    contract_startDate:
                      data?.contract_startDate &&
                      dayjs(data.contract_startDate).format('YYYY-MM-DD HH:mm:ss'),
                    contract_endDate:
                      data?.contract_endDate &&
                      dayjs(data.contract_endDate).format('YYYY-MM-DD HH:mm:ss'),
                    account_name: data?.account_name,
                    account_phone: data?.account_phone,
                    account_email: data?.account_email,
                    plan_id: data?.plan_id,
                    // 이미지
                    // photo_key: data?.photo_key,
                    // photo_path: data?.photo_path,
                    // photo_ext: data?.photo_ext,
                    file_id: data?.photoKey,
                  })
                  .then((res) => {
                    if (res?.data?.error) {
                      console.error('[error]', res?.data?.error);
                      message_error(
                        // `[Error Code: ${res?.data?.error?.code || '000'}] ${
                        //   res?.data?.error?.message ||
                        //   '센터를 등록하는데 실패하였습니다.'
                        // }(이메일 중복확인)`
                        `[Error Code: ${res?.data?.error?.code || '000'}] ${
                          res?.data?.error?.message ||
                          '센터를 등록하는데 실패하였습니다.'
                        }`
                      );

                      return res;
                    }
                    message_info('센터를 등록하였습니다.');

                    // 성공시에 만
                    setReFresh && setReFresh(new Date());
                    setTimeout(() => {
                      setGModal((prev) => {
                        return {
                          ...prev,
                          show: false,
                        };
                      });
                    }, [1000]);

                    return res;
                  })
                  .catch((e) => {
                    message_error(
                      `[Error] ${e || '센터를 등록하는데 실패하였습니다.'}`
                    );
                  });
              } else {
                message_error(errorMsg);
              }
            })();
          }}
        >
          {'추가'}
        </Button>
      </div>
      {/* ---------------------------------------------------------------------------------------------------- */}
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    width: '80%',
    height: '82rem',
    // height: '102.3rem',
    flexDirection: 'column',
    // justifyContents: 'space-between',
    // justifyContent: 'center',
    background: '#FFFFFF',
    boxshadow: '0px 5px 20px rgba(75, 70, 92, 0.4)',
    borderRadius: 6,
    paddingLeft: '3rem',
    paddingRight: '3rem',
  },
  footer: {
    display: 'flex',
    height: '5.8rem',
    justifyContent: 'flex-end',
    padding: '0px 24px 20px',
    marginTop: '2.4rem',
  },
};
export default CreateNewCenter;
